import React, { createContext } from 'react';
import { Merchant, Status, User, MerchantSettings, Country } from '@anticatrade/shared';
import { API } from '@anticatrade/admin';

interface AppContext {
	api: API;
	setIsLoadingState: React.Dispatch<React.SetStateAction<boolean>>;
	handleError: (err: Error | string) => void;
	showStatus: (status: Status) => void;
	toastRef: any;
	login: (email: string, password: string, captchaToken: string) => Promise<void>;
	logout: () => Promise<void>;
	redirect: (location: string) => void;
	user: User | undefined;
	settings: MerchantSettings | undefined;
	merchant: Merchant | undefined;
	refreshMerchant: () => Promise<void>;
	unreadMessagesCount: number | undefined;
	countries: Country[] | undefined;
	incrementUnreadMessagesCount: () => void;
	decrementUnreadMessagesCount: () => void;
}

const appContext = createContext<AppContext | undefined>(undefined);

export { appContext };
export type { AppContext };
